{
  "name": "@parkagent/ui",
  "version": "2.1.66",
  "description": "Parkagent UI Library",
  "main": "dist/index.js",
  "module": "./dist/index.es.js",
  "type": "module",
  "scripts": {
    "watch": "node build.js --watch",
    "build": "node build.js"
  },
  "repository": {
    "type": "git",
    "url": "git+https://SimonatoLuca@bitbucket.org/parkagent-team/parkagent-ui.git"
  },
  "author": "Opificio Lamantini Anonimi s.r.l.",
  "publishConfig": {
    "registry": "https://npm.parkagent.it"
  },
  "license": "ISC",
  "homepage": "https://bitbucket.org/parkagent-team/parkagent-ui#readme",
  "dependencies": {
    "@emotion/cache": "^11.11.0",
    "@emotion/react": "^11.11.1",
    "@mapbox/search-js-react": "^1.0.0-beta.18",
    "@phosphor-icons/react": "^2.1.5",
    "@tinymce/tinymce-react": "^5.0.1",
    "date-fns": "^2.30.0",
    "formik": "^2.4.1",
    "mapbox-gl": "^3.1.2",
    "react": "^18.2.0",
    "react-datepicker": "^6.2.0",
    "react-day-picker": "^8.10.0",
    "react-dom": "^18.2.0",
    "react-select": "^5.7.3",
    "react-swiper": "^0.1.5",
    "swiper": "^11.1.8",
    "validate.js": "^0.13.1"
  },
  "devDependencies": {
    "autoprefixer": "^10.4.17",
    "esbuild": "^0.20.0",
    "esbuild-plugin-clean": "^1.0.1",
    "esbuild-plugin-copy": "^2.1.1",
    "esbuild-plugin-eslint": "^0.3.7",
    "esbuild-style-plugin": "^1.6.3",
    "eslint": "^8.56.0",
    "eslint-plugin-react": "^7.33.2",
    "eslint-plugin-react-hooks": "^4.6.0",
    "postcss": "^8.4.35",
    "postcss-loader": "^6.2.1",
    "tailwindcss": "^3.4.1"
  }
}
